module.exports = __webpack_public_path__ + "img/img-map.5d62e523.svg";